import React, { useState } from 'react';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Stack, Grid, TextField, Container, Typography, InputAdornment, Divider, MenuItem } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { addVendorJob, updateVendorJob } from '../../../Redux-Store/actions/recruitment/vendorJobActions';
import ShowMessage from '../../../Component/ShowMessage';

const CreateVendorJob = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vendorFormData = useLocation();
  const vendorData = vendorFormData?.state?.vendorData;
  console.log('vendorData', vendorData);

  const [submitLoader, setSubmitLoader] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isShowUpdate, setIsShowUpdate] = useState(false);
  const [error, setError] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const LoginSchema = Yup.object().shape({
    job_Title: Yup.string()
      .required('Job Title is required'),

    job_Status: Yup.string()
      .required('Job Status is required'),

    job_Category: Yup.string()
      .required('Job Category  is required'),

    vendor_Name: Yup.string()
      .required('Vendor Name is required'),

    description: Yup.string()
      .required('Description is required')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      job_Title: vendorData ? vendorData.job_Title : '',
      job_Status: vendorData ? vendorData.job_Status : '',
      job_Category: vendorData ? vendorData.job_Category : '',
      vendor_Name: vendorData ? vendorData.vendor_Name : '',
      description: vendorData ? vendorData.description : '',
      remember: true,
    },
    validationSchema: LoginSchema,

    onSubmit: (value) => {
      setSubmitLoader(true);
      const params = vendorData
        ? {
          uuid: vendorData.uuid,
          job_Title: value.job_Title,
          job_Status: value.job_Status,
          job_Category: value.job_Category,
          vendor_Name: value.vendor_Name,
          description: value.description,
        }
        : {
          job_Title: value.job_Title,
          job_Status: value.job_Status,
          job_Category: value.job_Category,
          vendor_Name: value.vendor_Name,
          description: value.description,
        };
      if (vendorData?.uuid) {
        dispatch(updateVendorJob(params))
          .unwrap()
          .then((response) => {
            // setSubmitLoader(false);
            console.log('response in update reviewer', response);
            if (response.status === 200) {
              setSubmitLoader(false);
              setIsShowUpdate(true);
              setErrorMessage(response.data.message);
            }
            setTimeout(() => {
              setIsShowUpdate(false);
              navigate(-1);
            }, 1000);
          })
          .catch((error) => {
            console.log('error', error);
            if (error.response.status === 400) {
              console.log('error', error.response.status, error.response.data.error);
              setIsShowUpdate(true);
              setErrorUpdate(true);
              setErrorMessage(error.response.data.error);
              setTimeout(() => {
                setIsShowUpdate(false);
              }, 3000);
            } else {
              setErrorUpdate(false);
            }
          });
      } else {
        dispatch(addVendorJob(params))
          .unwrap()
          .then((response) => {
            console.log('response of add reviewer', response);
            if (response.status === 200) {
              setSubmitLoader(false);
              setIsShowUpdate(true);
              setErrorMessage(response.data.message);
            }
            setTimeout(() => {
              setIsShowUpdate(false);
              navigate(-1);
            }, 1500);
          })
          .catch((error) => {
            console.log('error', error);
            if (error.response.status === 409) {
              console.log('error', error.response.status, error.response.data.error);
              setSubmitLoader(false);
              setIsShowUpdate(true);
              setErrorUpdate(true);
              setErrorMessage(error.response.data.error);
              setTimeout(() => {
                setIsShowUpdate(false);
              }, 3000);
            } else {
              setErrorUpdate(false);
            }
          });
      }
    },
  });
  const { errors, touched, getFieldProps } = formik;
  return (
    <div>
      <Container id="reviewer" sx={{ width: '100%' }} maxWidth="xl">
        <Typography variant="h6" fontWeight={'600'}>
          {vendorData ? ' Update Vendor Job' : ' Create Vendor Job'}
        </Typography>
        <Typography fontSize={14}>Enter your Vendor Job details</Typography>

        <Divider sx={{ mt: '10px' }} />
        <Card sx={{ padding: '20px', paddingRight: '80px' }}>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Stack spacing={3} sx={{ mt: 3 }}>
                <Grid container spacing={4}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      autoComplete="job_Title"
                      label="Job Title*"
                      {...getFieldProps('job_Title')}
                      error={Boolean(touched.job_Title && errors.job_Title)}
                      helperText={touched.job_Title && errors.job_Title}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      autoComplete="job_Status"
                      label="Job Status*"
                      select
                      {...getFieldProps('job_Status')}
                      InputProps={{
                        endAdornment: <InputAdornment position="end" />,
                      }}
                      error={Boolean(touched.job_Status && errors.job_Status)}
                      helperText={touched.job_Status && errors.job_Status}
                    >
                      <MenuItem value="Open">Open</MenuItem>
                      <MenuItem value="Close">Close</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      autoComplete="job_Category"
                      type="text"
                      label="Job Category*"
                      {...getFieldProps('job_Category')}
                      InputProps={{
                        endAdornment: <InputAdornment position="end" />,
                      }}
                      error={Boolean(touched.job_Category && errors.job_Category)}
                      helperText={touched.job_Category && errors.job_Category}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      autoComplete="vendor_Name"
                      type="text"
                      label="Vendor Name*"
                      {...getFieldProps('vendor_Name')}
                      InputProps={{
                        endAdornment: <InputAdornment position="end" />,
                      }}
                      error={Boolean(touched.vendor_Name && errors.vendor_Name)}
                      helperText={touched.vendor_Name && errors.vendor_Name}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      autoComplete="description"
                      type="text"
                      label="Description*"
                      {...getFieldProps('description')}
                      InputProps={{
                        endAdornment: <InputAdornment position="end" />,
                      }}
                      error={Boolean(touched.description && errors.description)}
                      helperText={touched.description && errors.description}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <LoadingButton
                      //   loading={submitLoader && true}
                      size="large"
                      type="submit"
                      variant="contained"
                      style={{ float: 'right' }}
                    >
                      {vendorData ? 'Update' : ' Submit'}
                    </LoadingButton>
                  </Grid>
                  <Grid item xs={5} />
                </Grid>
              </Stack>
            </Form>
          </FormikProvider>
        </Card>
      </Container>

      <ShowMessage
        onClose={() => setIsShow(false)}
        title={errorMessage}
        type={error ? 'error' : 'success'}
        open={isShow}
      />
      <ShowMessage
        onClose={() => setIsShowUpdate(false)}
        title={errorMessage}
        type={errorUpdate ? 'error' : 'success'}
        open={isShowUpdate}
      />
    </div>
  );
};

export default CreateVendorJob;
